import { i18n } from '@e-kyc/translations';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { configuration } from '../../../configuration';

interface TermsContentProps {
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
}

export default function TermsContent(props: TermsContentProps) {
  const { onScroll } = props;
  const { language } = i18n as { language: 'th' | 'en' };
  const [content, setContent] = useState<string>('');

  useEffect(() => {
    const fetchContent = async () => {
      const { data } = await axios.get(configuration.termsAndConditions.url[language]);
      setContent(data);
    };
    fetchContent();
  }, [language]);

  return (
    <div className='flex h-dvh flex-col items-center justify-center pt-4 pb-[166px]'>
      <div
        className='mb-2 flex h-full w-full flex-col gap-6 overflow-y-scroll px-4 pb-4'
        onScroll={onScroll}
      >
        <Markdown
          remarkPlugins={[remarkGfm]}
          components={{
            h2: ({ children, ...props }) => (
              <h2 {...props} className='text-center'>
                {children}
              </h2>
            ),
            h3: ({ children, ...props }) => <h3 {...props}>{children}</h3>,
            h4: ({ children, ...props }) => <h4 {...props}>{children}</h4>,
            h5: ({ children, ...props }) => <h5 {...props}>{children}</h5>,
            h6: ({ children, ...props }) => <h6 {...props}>{children}</h6>,
            p: ({ ...props }) => <p className='text-body1' {...props} />,
            ul: ({ ...props }) => <ul className='list-disc pl-6' {...props} />,
            li: ({ ...props }) => <li className='text-body1' {...props} />,
            a: ({ children, ...props }) => (
              <a target='_blank' rel='noopener noreferrer' {...props}>
                {children}
              </a>
            ),
          }}
        >
          {content}
        </Markdown>
      </div>
    </div>
  );
}
